// src/services/data.service.js
import api from './api';

class DataService {
  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    return api.post('/agua/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 30000, // 30 segundos de timeout para archivos grandes
    });
  }

  getDailyData(date) {
    return api.get(`/agua/daily?date=${date}`);
  }

  getWeeklyData() {
    return api.get('/agua/weekly');
  }
}

export default new DataService();